<div
  bsModal
  #modal="bs-modal"
  class="modal fade"
  tabindex="-1"
  aria-hidden="true"
>
  <div role="document" class="modal-dialog modal-md">
    <div class="modal-content generic-container">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Fechar"
          (click)="hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body generic-body">
        <div class="row">
          <div class="col-xs-12">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
